var map = {
	"./contact.svg": "97ad",
	"./home.svg": "cb4b",
	"./inge_map.svg": "690e",
	"./inge_whatsapp.svg": "ea0e",
	"./logo-ingeray.svg": "c0d6",
	"./logo-ingeray1.svg": "939a",
	"./map.svg": "e266",
	"./products.svg": "616d",
	"./services.svg": "3d2e",
	"./whatsapp.svg": "d2ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7991";